import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const ArrangeBackward = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fill={color}
          fillRule="evenodd"
          d="M4.986 10.966a.5.5 0 1 1 .716-.698L7.5 12.116V5.703a.5.5 0 1 1 1 0v6.413l1.798-1.848a.5.5 0 1 1 .716.698l-2.656 2.73a.5.5 0 0 1-.716 0l-2.656-2.73ZM2.119 6.598l4.243 2.121V7.601L2.567 5.703 7.777 3.1a.5.5 0 0 1 .447 0l5.21 2.604-3.796 1.898V8.72l4.242-2.121a1 1 0 0 0 0-1.789L8.67 2.204a1.5 1.5 0 0 0-1.34 0L2.12 4.81a1 1 0 0 0 0 1.789Z"
          clipRule="evenodd"
        />
      </svg>
    )
  },
)

export default ArrangeBackward
